import axios from "axios"
import { Formik } from "formik"
import React, { useEffect, useState } from "react"
import { useHistory } from "react-router-dom"
import { Button, Form, FormGroup, Input, Table } from "reactstrap"

const RegionCosts = ({ setAuth }) => {
  const history = useHistory()

  const [regionList, setRegionList] = useState([])
  const [editing, setEditing] = useState(false)

  useEffect(() => {
    const formData = {
      PerToken: localStorage.getItem("token"),
      PerUserID: localStorage.getItem("id"),
      PerRoleID: localStorage.getItem("userRoleID"),
    }

    axios
      .post(
        process.env.REACT_APP_API_URL+"api/CostEstimation/RegionCostList.php",
        formData
      )
      .then(res => {
        if (res.data.error === true && res.data.message === "Access denied!") {
          setAuth(true)
          setTimeout(() => {
            history.push("/logout")
            setTimeout(() => {
              history.push("/login")
            }, 1000)
          }, 4000)
        }

        // console.log(res.data)
        let array = Object.values(res.data)
        array.splice(-1)
        setRegionList(array)
      })
      .catch(err => console.log(err))
  }, [editing])

  const initialValues = {}
  regionList.map((item, i) => {
    initialValues[`NCost-${i + 1}`] = item.NCost
    initialValues[`ECost-${i + 1}`] = item.ECost
    initialValues[`LCost-${i + 1}`] = item.LCost
  })

  const validateHandler = values => {
    let errors = {}

    for (let i = 0; i < regionList.length; i++) {
      if (values[`NCost-${i + 1}`] <= 0)
        errors[`NCost-${i + 1}`] = "value must be greater than 0"
      if (values[`NCost-${i + 1}`] === "") errors[`NCost-${i + 1}`] = "required"

      if (values[`ECost-${i + 1}`] <= 0)
        errors[`ECost-${i + 1}`] = "value must be greater than 0"
      if (values[`ECost-${i + 1}`] === "") errors[`ECost-${i + 1}`] = "required"

      if (values[`LCost-${i + 1}`] <= 0)
        errors[`LCost-${i + 1}`] = "value must be greater than 0"
      if (values[`LCost-${i + 1}`] === "") errors[`LCost-${i + 1}`] = "required"
    }

    console.log("values ===========>", values)
    console.log("errors ===========>", errors)

    return errors
  }

  const submitHandler = values => {

    const formData = {
      PerToken: localStorage.getItem("token"),
      PerUserID: localStorage.getItem("id"),
      PerRoleID: localStorage.getItem("userRoleID"),
      RegionCostArray: [],
    }

    for (let i = 0; i < regionList.length; i++) {
      formData.RegionCostArray.push({
        RCID: regionList[i].RCID,
        NCost: values[`NCost-${i + 1}`],
        ECost: values[`ECost-${i + 1}`],
        LCost: values[`LCost-${i + 1}`],
      })
    }

    axios
      .post(
        process.env.REACT_APP_API_URL+"api/CostEstimation/EditRegionCost.php",
        formData
      )
      .then(res => {
        if (res.data.error === true && res.data.message === "Access denied!") {
          setAuth(true)
          setTimeout(() => {
            history.push("/logout")
            setTimeout(() => {
              history.push("/login")
            }, 1000)
          }, 4000)
        }

        // console.log(res)
        setEditing(!editing)
      })
      .catch(err => console.log(err))
  }

  return (
    <div style={{ width: "75%" }}>
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validate={validateHandler}
        onSubmit={submitHandler}
      >
        {props => (
          <Form onSubmit={props.handleSubmit}>
            <Table className="project-list-table table-nowrap align-middle table-borderless">
              <thead>
                <tr>
                  <th>Region</th>
                  <th>
                    Normal (cost/m<sup>2</sup>)
                  </th>
                  <th>
                    Economy (cost/m<sup>2</sup>)
                  </th>
                  <th>
                    Luxuary (cost/m<sup>2</sup>)
                  </th>
                </tr>
              </thead>
              <tbody>
                {regionList.map((item, i) => (
                  <tr key={i}>
                    <td>{item.Name}</td>
                    <td>
                      <Input
                        type="number"
                        min={0}
                        name={`NCost-${i + 1}`}
                        id={`NCost-${i + 1}`}
                        value={props.values[`NCost-${i + 1}`]}
                        onChange={props.handleChange}
                        onBlur={props.handleBlur}
                        className="form-control"
                        placeholder="Normal Cost ..."
                      />
                      {props.touched[`NCost-${i + 1}`] &&
                        props.errors[`NCost-${i + 1}`] && (
                          <span className="error mx-1 d-flex justify-content-end">
                            {props.errors[`NCost-${i + 1}`]}
                          </span>
                        )}
                    </td>
                    <td>
                      <Input
                        type="number"
                        min={0}
                        name={`ECost-${i + 1}`}
                        id={`ECost-${i + 1}`}
                        value={props.values[`ECost-${i + 1}`]}
                        onChange={props.handleChange}
                        onBlur={props.handleBlur}
                        className="form-control"
                        placeholder="Economic Cost ..."
                      />
                      {props.touched[`ECost-${i + 1}`] &&
                        props.errors[`ECost-${i + 1}`] && (
                          <span className="error mx-1 d-flex justify-content-end">
                            {props.errors[`ECost-${i + 1}`]}
                          </span>
                        )}
                    </td>
                    <td>
                      <Input
                        type="number"
                        min={0}
                        name={`LCost-${i + 1}`}
                        id={`LCost-${i + 1}`}
                        value={props.values[`LCost-${i + 1}`]}
                        onChange={props.handleChange}
                        onBlur={props.handleBlur}
                        className="form-control"
                        placeholder="Luxuary Cost ..."
                      />
                      {props.touched[`LCost-${i + 1}`] &&
                        props.errors[`LCost-${i + 1}`] && (
                          <span className="error mx-1 d-flex justify-content-end">
                            {props.errors[`LCost-${i + 1}`]}
                          </span>
                        )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>

            <FormGroup className="d-flex ms-auto col-4 mt-5 justify-content-end">
              <Button
                type="submit"
                className="bg-primary"
                // disabled={
                //   userPermissions.R7.P !== "3" && userPermissions.R7.P !== "4"
                // }
              >
                Update
              </Button>
            </FormGroup>
          </Form>
        )}
      </Formik>
    </div>
  )
}

export default RegionCosts
